import {PriceRobotCustomFields} from "./price-robot-custom-fields";
import {Product, ProductInterface} from "@hassel-it/shop-services";
import {Package, PackageInterface} from "./package";
import {CrawlerLog, CrawlerLogInterface} from "./price-robot-crawler-log";
import {PriceRobotCompetitor} from "./price-robot-competitor";


export class PriceRobotUrl {

    id: number;
    products?: Product[] = [];
    product?: Product;
    url?: string;
    name?: string;
    last_error?: string;
    last_log?: string;
    is_approved?: boolean;
    has_error?: boolean;
    ean?: number;
    screenshot_url?: string;
    original_screenshot_url?: string;
    orginal_id?: any;
    product_id?: number;
    score?: number;
    crawler_website_id?: any;
    crawler_website?: PriceRobotCompetitor;
    crawler_logs?: CrawlerLog[];
    last_measurement?:any;
    crawler_disabled?:boolean;
    apply_conversion?:boolean;

    diff?:number;
    pct_div?:number;

    static _JSONProps: string[] = [
        'url',
        'id',
        'score',
        'name',
        'is_approved',
        'screenshot_url',
        'product_id',
        'has_error',
        'crawler_website_id',
        'last_error',
        'last_measurement',
        'crawler_disabled',
        'apply_conversion'
    ];

    constructor(initializer?: PriceRobotUrlInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: PriceRobotUrlInterface | string): PriceRobotUrl {
        if (json === null) {
            return new PriceRobotUrl();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, PriceRobotUrl.reviver);
        } else {
            let task = new PriceRobotUrl();
            let extra = {products: [], product: null, crawler_logs: [], crawler_website: null};

            Object.keys(json).forEach((key, index) => {
              //  console.log(json['last_measurement']);
                if (PriceRobotUrl._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }

                if (key === 'crawler_website') {
                    extra.crawler_website = PriceRobotCompetitor.fromJSON(json[key]);
                }

                if (key === 'products') {
                    json[key].forEach((value: ProductInterface, index) => {
                        extra.products.push(Product.fromJSON(value));
                        extra.product = Product.fromJSON(value);
                    });
                }

                if (key === 'crawler_logs') {
                    json[key].forEach((value: CrawlerLogInterface, index) => {
                        extra.crawler_logs.push(CrawlerLog.fromJSON(value));
                    });
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? PriceRobotUrl.fromJSON(value) : value;
    }

}

export interface PriceRobotUrlInterface extends PriceRobotUrl {
}
